var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFocusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1815 12.9456C53.9633 12.9456 51.607 17.1346 52.567 20.2473L42.2398 30.6036C41.367 30.3418 40.087 30.3418 39.2143 30.6036L31.7962 23.1855C32.7853 20.0728 30.4289 15.8546 26.1817 15.8546C21.9635 15.8546 19.5781 20.0437 20.5672 23.1855L7.30178 36.4218C4.18907 35.4618 0 37.8181 0 42.0363C0 45.2363 2.61817 47.8545 5.81815 47.8545C10.0363 47.8545 12.3927 43.6654 11.4327 40.5527L24.669 27.2873C25.5417 27.5491 26.8217 27.5491 27.6944 27.2873L35.1125 34.7054C34.1234 37.8181 36.4798 42.0363 40.727 42.0363C44.9452 42.0363 47.3306 37.8472 46.3416 34.7054L56.6979 24.3782C59.8106 25.3382 63.9996 22.9819 63.9996 18.7637C63.9996 15.5637 61.3815 12.9456 58.1815 12.9456Z",
    fill: "#DA3273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 16L42.5064 10.48L47.9998 8L42.5064 5.52L39.9998 0L37.5464 5.52L31.9998 8L37.5464 10.48L39.9998 16Z",
    fill: "#DA3273"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33293 21.3333L10.6663 16L15.9996 14.6667L10.6663 13.3333L9.33293 8L7.99959 13.3333L2.66626 14.6667L7.99959 16L9.33293 21.3333Z",
    fill: "#DA3273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusIcon);
export default __webpack_public_path__ + "static/media/focus-icon.f4981c9e.svg";
export { ForwardRef as ReactComponent };